<template>
  <div
    v-if="alertIsVisible"
    class="
      mt-6
      px-5
      py-4
      flex
      font-normal
      text-sm text-gray-900
      rounded-lg
      shadow-md
      bg-vice-light-beige
      border border-vice-yellow
      dark:bg-gray-800
      dark:text-red-400
      dark:border-red-800
    "
    role="alert"
  >
    <ExclamationIcon class="w-7 h-7 mr-3" />
    <div class="leading-7">
      <span class="font-semibold text-black">Device setup required</span>
      <p class="leading-5 text-gray-600">
        Your preferred devices haven't been configured yet. Set up your camera, microphone and
        speakers before joining a session to avoid connection issues and ensure the best experience.
      </p>
      <div class="flex items-center mt-2 -ml-2 font-semibold">
        <template v-for="device in getDevicesToSetup()" :key="device">
          <span class="flex items-center text-xs text-gray-500 leading-6 mr-4">
            <ViceCamera v-if="device === 'camera'" class="w-8 h-8" pathFill="#606367" />
            <MicrophoneForAlertIcon v-if="device === 'microphone'" class="w-5 h-5 mx-1" />
            <ViceSpeakers v-if="device === 'speaker'" class="w-4 h-4 m-2" pathFill="#606367" />
            No {{ device }} selected
          </span>
        </template>
      </div>
      <div class="flex mt-2 content-center gap-3">
        <!-- setup devices button -->
        <inertia-link :href="getLinkToDeviceSetupPage()" class="inline-block">
          <ViceButton data-cy="setup-device-button" class="font-semibold px-4" icon="CogIcon" small>
            Set up devices now
          </ViceButton>
        </inertia-link>
        <!-- remind me later button -->
        <ViceButton
          data-cy="remind-later-button"
          class="font-semibold px-4"
          @click="closeAlert()"
          small
          white
        >
          Remind me later
        </ViceButton>
      </div>
    </div>

    <button
      type="button"
      class="ms-auto -mx-1 inline-flex items-center justify-center h-6 w-6 ml-auto"
      aria-label="Close"
      @click="closeAlert()"
    >
      <span class="sr-only">Close</span>
      <CrossedBlackIcon />
    </button>
  </div>
</template>
<script>
// All component logic in ProfileAlertMixin.vue!!!
import DeviceSetupAlertMixin from '@/Mixins/DeviceSetupAlertMixin.vue';
import { ALERTS_SEEN_COOKIES_NAMES } from '@/Utils/vice-constants';
import CrossedBlackIcon from '@/Components/Icons/CrossedBlackIcon.vue';
import ExclamationIcon from '@/Components/Icons/ExclamationIcon.vue';
import ViceCamera from '@/Components/Icons/ViceCamera.vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import ViceSpeakers from '@/Components/Icons/ViceSpeakers.vue';
import MicrophoneForAlertIcon from '@/Components/Icons/MicrophoneForAlertIcon.vue';

export default {
  name: 'NoDeviceSetupAlert',
  components: {
    MicrophoneForAlertIcon,
    ViceSpeakers,
    ExclamationIcon,
    ViceButton,
    ViceCamera,
    CrossedBlackIcon,
  },
  mixins: [DeviceSetupAlertMixin],
  data() {
    return {
      device_setup_exist: 'device_setup_exist',
      alertSeenCookieName: ALERTS_SEEN_COOKIES_NAMES.NO_DEVICE_SETUP_ALERT_SEEN,
    };
  },
};
</script>

<style scoped>
.profile-link {
  color: inherit;
  padding: 0;
}

.profile-link:hover {
  background: none;
}
</style>
